import { reactive } from 'vue'

export interface TopNotificationOptions {
  avatar?: string
  title: string
  description: string
  badge?: string | number
  duration?: number
  onClick?: () => void
}

interface NotificationState {
  show: boolean
  avatar: string
  title: string
  description: string
  badge: string | number
  duration: number
  onClick?: () => void
}

// 全局状态
export const notificationState = reactive<NotificationState>({
  show: false,
  avatar: '',
  title: '',
  description: '',
  badge: '',
  duration: 3000,
  onClick: undefined
})

/**
 * 显示顶部通知
 * @param options 通知选项
 * @example
 * ```ts
 * showTopNotification({
 *   avatar: '/path/to/avatar.jpg',
 *   title: 'Amelia',
 *   description: 'Her voice floated from a distance...',
 *   badge: '1',
 *   duration: 3000,
 *   onClick: () => {
 *     console.log('Notification clicked')
 *   }
 * })
 * ```
 */
export const showTopNotification = (options: TopNotificationOptions) => {
  notificationState.show = true
  notificationState.avatar = options.avatar || ''
  notificationState.title = options.title
  notificationState.description = options.description
  notificationState.badge = options.badge || ''
  notificationState.duration = options.duration ?? 3000
  notificationState.onClick = options.onClick
}

/**
 * 隐藏顶部通知
 */
export const hideTopNotification = () => {
  notificationState.show = false
}

/**
 * Composable 用于在组件中使用
 */
export const useTopNotification = () => {
  return {
    show: showTopNotification,
    hide: hideTopNotification,
    state: notificationState
  }
}

// 挂载到 window 对象供全局使用
if (typeof window !== 'undefined') {
  (window as any).showTopNotification = showTopNotification;
  (window as any).hideTopNotification = hideTopNotification
}

